var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"rounded",attrs:{"icon":"","color":"orange","large":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',[_vm._v("mdi-refresh")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }